import axios from 'axios';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

class CredoError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

// pk_demo-cSROQYWl6wQKdad5b3VPDEND8IvQA2.TZgyovTBPq-d THIS IS FOR CREDO CENTRAL

// pk_demo-t0GSknXb9EoCc6ZxYe3IdwhncUJGmS.Xw3SGKcUTV-d THIS IS FOR CREDO NUGI

// const baseUrl = 'https://api.credocentral.com/credo-payment/v1';
// const credoCentralPublicTestKey =
//   'pk_demo-cSROQYWl6wQKdad5b3VPDEND8IvQA2.TZgyovTBPq-d';

const baseUrl = 'https://credo-payments.nugitech.com/v1';
const credoNugiPublicTestKey =
  'pk_demo-t0GSknXb9EoCc6ZxYe3IdwhncUJGmS.Xw3SGKcUTV-d';

const instance = axios.create({
  baseURL: baseUrl,
});

const CredoService = {
  SUCCESS_RESPONSE_CODE: '200',

  initiatePayment: async function(data) {
    NProgress.start();
    try {
      const response = await instance.post('/payments/initiate', data, {
        headers: {
          Authorization: credoNugiPublicTestKey,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      NProgress.done();
      return response.data;
    } catch (error) {
      NProgress.done();
      throw new CredoError(error.response.status, error.response.data.detail);
    }
  },
};

export { CredoService, CredoError };
